import request from '@/utils/request'

export function store(data) {
  return request({
    url: 'typeDocument/store',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: 'typeDocument/update',
    method: 'put',
    data
  })
}

export function deleteData(id) {
  return request({
    url: 'typeDocument/destroy/' + id,
    method: 'delete'
  });
}

export function getAll() {
  return request({
    url: 'typeDocument/getAll',
    method: 'get'
  })
}

export function getById(id) {
  return request({
    url: 'typeDocument/getById/' + id,
    method: 'get'
  });
}
